import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';
import { NotifierService } from 'angular-notifier';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '@app/environments/environment';

declare var Stripe: any;

const stripe = Stripe(environment.stripe.key);
const elements = stripe.elements();

const card = elements.create('card');

@Component({
  selector: 'app-add-card',
  templateUrl: './add-card.component.html',
  styleUrls: ['./add-card.component.css']
})
export class AddCardComponent implements OnInit, AfterViewInit {
  @ViewChild('cardElement') cardElement: ElementRef;

  processing = false;

  @Output()
  public addCardResult = new EventEmitter();

  constructor(
    private fun: AngularFireFunctions,
    private notifier: NotifierService,
    private ngbModal: NgbModal
  ) { }

  ngOnInit() { }

  ngAfterViewInit(): void {
    card.mount(this.cardElement.nativeElement);

    card.addEventListener('change', (event) => {
      const displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });
  }

  async handleForm() {
    this.processing = true;
    const { token, error } = await stripe.createToken(card);

    if (error) {
      // Inform the customer that there was an error.
      this.notifier.notify(
        'error',
        'Unable to add card. Please enter your card details correctly'
      );
    } else {
      try {
        const cardInfo = await this.fun.httpsCallable('addCard')({ source: token.id }).toPromise();
        if (
          cardInfo
          && cardInfo.result
          && !cardInfo.error
        ) {
          this.notifier.notify('success', 'Card Successfully Added');
          this.ngbModal.dismissAll();
          this.addCardResult.emit({ token: token.id });
          return 'Success';
        } else {
          throw Error(cardInfo);
        }
      } catch (addCardErr) {
        this.notifier.notify(
          'error', addCardErr
          ? 'Unable to add payment option. Please try again.'
          : 'Unknown error. Kindly report to help@rentreef.com.'
        );
        this.ngbModal.dismissAll();
        return addCardErr;
      }
    }
    this.processing = false;
  }

  async addCardToDb() {
    const { token, error } = await stripe.createToken(card);

    if (error) {
      // Inform the customer that there was an error.
      return error;
    } else {
      try {
        const res = await this.fun.httpsCallable('addCard')({ source: token.id }).toPromise();
        return res;
      } catch (error) {
        return error;
      }
    }
  }

  async createCardToken() {
    const { token, error } = await stripe.createToken(card);

    if (error) {
      // Inform the customer that there was an error.
      this.notifier.notify(
        'error',
        'Unable to add card. Please enter your card details correctly'
      );
      return error;
    } else {
      return token;
    }
  }
}
